export default __webpack_public_path__ + "static/media/wordpress.a87274ea.jpg";